import { render, staticRenderFns } from "./ConnectTipDialog.vue?vue&type=template&id=3f74f9e8&scoped=true&"
import script from "./ConnectTipDialog.vue?vue&type=script&lang=js&"
export * from "./ConnectTipDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConnectTipDialog.vue?vue&type=style&index=0&id=3f74f9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74f9e8",
  null
  
)

export default component.exports